import deMessages from "@/lang/de.json";
import enMessages from "@/lang/en.json";

export type SupportedLocale = "en" | "de";

const messages = {
  en: enMessages,
  de: deMessages,
};

export function resolveSupportedLocale(language: string): SupportedLocale {
  return language === "de" ? "de" : "en";
}

export function getLocaleMessages(language: string) {
  const locale = resolveSupportedLocale(language);

  return {
    locale,
    messages: messages[locale],
  };
}
